import React from 'react'

export default function BetaBugReport() {
  return (
    <div>
        <h1>Bug Report</h1>
        <hr />
    </div>
  );
}